import * as Sentry from "@sentry/react";

// Single entry point for unexpected errors.
// dev: console.error (Sentry not initialized locally)
// prod/staging: Sentry.captureException (console.* is no-op'd in index.js)
export default function reportError(message, error = null, context = {}) {
  try {
    console.error(message, error, context);
    const isError = error instanceof Error;
    const err = isError ? error : new Error(message);
    const extra = { ...context };
    if (!isError && error != null) extra.original = error;
    Sentry.captureException(err, { extra });
  } catch (_) {
    // never let reporting throw
  }
}
